// extracted by mini-css-extract-plugin
export default {"chips":"CountrySelectV2Wrapper_chips__efgXT","rememberCheckBox":"CountrySelectV2Wrapper_rememberCheckBox__snKRR"};